// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const VideoTest: MarkdocTagRegistration = {
  tag: 'video-test',
  component: 'VideoTest',
  attributes: {
    videoId: {type: String, required: false},
    topicId: {type: String, required: false},
    showAll: {type: Boolean, required: false},
  },
};
